import { useGameStore } from '@/shared/hooks/use-shallow-store';
import { useT } from '@/shared/lib/i18n';
import { HandoffComplete } from '../ui/HandoffComplete';

/**
 * Standalone "all alive players have voted" intermission. The engine has
 * already transitioned to the next phase by the time we land here — the CTA
 * just flips the local handoff into the round-end UI.
 */
export const VoteCompleteOrchestrator = () => {
  const t = useT();
  const showRoundEnd = useGameStore((s) => s.showRoundEnd);

  return (
    <HandoffComplete
      title={t('play.handoff.all_voted_title')}
      description={t('play.handoff.all_voted_description')}
      ctaLabel={t('play.handoff.reveal')}
      onContinue={showRoundEnd}
    />
  );
};
